import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dashboard mt-2" }
const _hoisted_2 = { class: "roba-container" }
const _hoisted_3 = { class: "roboto-slab flex flex-align-end" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "dashboard__last-visit ml-05" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "grid pb-4" }
const _hoisted_8 = { class: "roba-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_document_updated_block = _resolveComponent("document-updated-block")!
  const _component_image_block = _resolveComponent("image-block")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _createElementVNode("span", {
          textContent: _toDisplayString(_ctx.$t("DASHBOARD.DOCUMENTS_ADDED"))
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", {
            textContent: _toDisplayString(_ctx.$t("DASHBOARD.LAST_VISIT"))
          }, null, 8, _hoisted_6),
          _createTextVNode(": " + _toDisplayString(_ctx.formatDateValue(_ctx.currentUser.lastLoginDate)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentSummary, (summary, index) => {
          return (_openBlock(), _createBlock(_component_document_updated_block, {
            summary: summary,
            lastLoginDate: _ctx.currentUser.previousLastLoginDate,
            key: `document${index}`
          }, null, 8, ["summary", "lastLoginDate"]))
        }), 128))
      ])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_image_block)
    ])
  ]))
}